import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Colors, LOGO2 } from "../../assets";
import { useRootStore } from "../../stores";
import "./styles.css";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RegularTextInput } from "../../components";

const Login = () => {
  const { i18n, t } = useTranslation();
  const {
    passwordInput,
    usernameInput,
    setPassword,
    setUsername,
    fetchPlace,
    changeFetchLoading,
    Login,
    passwordError,
    usernameError,
    changePasswordError,
    changeUsernameError,
    loginError,
  } = useRootStore().rootStore.placeStore;
  const [loading, setLoading] = useState(false);
  const { setCurrentPage } = useRootStore().rootStore.drawerStore;

  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);

  return (
    <div className="login">
      <header className="loginHeader">
        <img className="logo" src={LOGO2} alt="" />
      </header>
      <div className="body">
        <form className="form">
          {/* <div className="inputWrapper">
            <label
              className="label"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {t("Username")}
              <input
                value={usernameInput}
                className="input"
                type="text"
                placeholder={t("username")}
                onChange={(event) => setUsername(event.currentTarget.value)}
                style={{
                  fontFamily:
                    i18n.language === "ar"
                      ? "'Cairo', sans-serif"
                      : "'Rubik', sans-serif",
                }}
              />
            </label>
            <img
              className="x-icon"
              src={XIcon}
              alt=""
              height={20}
              width={20}
              style={
                i18n.language === "en"
                  ? {
                      borderLeft: 1,
                      borderLeftColor: "#520989",
                      borderLeftStyle: "solid",
                      paddingLeft: "2%",
                    }
                  : {
                      borderRight: 1,
                      borderRightColor: "#520989",
                      borderRightStyle: "solid",
                      paddingRight: "2%",
                    }
              }
              onClick={() => setUsername("")}
            />
          </div> */}
          <RegularTextInput
            value={usernameInput}
            title={t("Username")}
            onChange={(event) => {
              typeof event !== "string"
                ? setUsername(event.currentTarget.value)
                : setUsername(event);
              typeof event === "string"
                ? event === ""
                  ? changeUsernameError(t("Please enter your username"))
                  : changeUsernameError("")
                : event.currentTarget.value === ""
                  ? changeUsernameError(t("Please enter your username"))
                  : changeUsernameError("");
            }}
            borderColor={Colors.GREEN}
            error={usernameError !== ""}
            onErrorText={t(usernameError)}
            inputType="text"
          />
          <RegularTextInput
            value={passwordInput}
            title={t("Password")}
            onChange={(event) => {
              typeof event !== "string"
                ? setPassword(event.currentTarget.value)
                : setPassword(event);
              typeof event === "string"
                ? event === ""
                  ? changePasswordError(t("Please enter your password"))
                  : changePasswordError("")
                : event.currentTarget.value === ""
                  ? changePasswordError(t("Please enter your password"))
                  : changePasswordError("");
            }}
            borderColor={Colors.GREEN}
            error={passwordError !== ""}
            onErrorText={t(passwordError)}
            inputType="password"
          />
          <button
            className="submit"
            onClick={async (e) => {
              e.preventDefault();
              if (usernameInput !== "" && passwordInput !== "") {
                changeFetchLoading(true);
                setLoading(true);
                changePasswordError("");
                changeUsernameError("");
                await Login();
                await fetchPlace().then((data) => {
                  if (data === undefined) return;
                  // Push notification init is handled by App.tsx after navigation
                  setCurrentPage("main");
                  changeFetchLoading(false);
                });
                setLoading(false);
              } else {
                usernameInput === ""
                  ? changeUsernameError(t("Please enter your username"))
                  : changeUsernameError("");
                passwordInput === ""
                  ? changePasswordError(t("Please enter your password"))
                  : changePasswordError("");
              }
            }}
            style={{
              fontFamily:
                i18n.language === "ar"
                  ? "'Cairo', sans-serif"
                  : "'Rubik', sans-serif",
            }}
          >
            {loading ? (
              <CircularProgress
                className="MuiCircularProgress-colorPrimary"
                size={20}
              />
            ) : (
              t("Login")
            )}
          </button>
          <p className="inputError">{t(loginError)}</p>
        </form>
      </div>
    </div>
  );
};

export default observer(Login);
